import { BooleanField } from "@imi-ernd-be/hyselect-engine";
import { assert, isObject } from "radashi";

export type BooleanFieldDefinition = {
  default: boolean;
  disabled: boolean;
  id: string;
  translationKey: string;
  type: "boolean";
  value: boolean;
};

export function getBooleanDefinition(
  field: BooleanField | null,
): BooleanFieldDefinition {
  assert(field, "BooleanField is null in getBooleanDefinition");
  return {
    default: field.default,
    disabled: field.disabled,
    id: field.id,
    translationKey: field.translationKey,
    type: "boolean",
    value: field.value,
  };
}

export function isBooleanDefinition(
  definition: unknown,
): definition is BooleanFieldDefinition {
  if (!isObject(definition)) return false;
  const def = definition as Record<string, unknown>;
  return def.type === "boolean";
}
